// extracted by mini-css-extract-plugin
export default {"card":"b3-z"};